import { z } from "zod";
import { twinQueryInterfaceSchema } from "./twin-query-interface.js";
export const twinFeedbackCreateInputSchema = z.object({
    interfaceType: twinQueryInterfaceSchema.default("api"),
    description: z.string().trim().min(1).max(8_000),
    queryId: z.string().trim().min(1).max(200).optional(),
}).strict().meta({ title: "TwinFeedbackCreateInput" });
export const twinFeedbackResourceSchema = z.object({
    id: z.string().trim().min(1),
    interfaceType: twinQueryInterfaceSchema,
    queryId: z.string().trim().min(1).max(200).optional(),
    createdAt: z.number().int().nonnegative(),
}).strict();
export const twinFeedbackCreateResponseSchema = z.object({
    feedback: twinFeedbackResourceSchema,
}).strict().meta({ title: "TwinFeedbackCreateResponse" });
